import type { WhatsappReachFilter } from '@/shared/types/campaign';

export interface ReachStatus {
  label: string;
  variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive';
  filter?: WhatsappReachFilter;
}

/** Interpreta `received` da API de campanhas WhatsApp (legado). */
export function whatsappReachStatus(received?: number): ReachStatus {
  const v = received ?? 0;
  if (v === 0) return { label: 'Enviando', variant: 'warning', filter: 'sending' };
  if (v === -1) return { label: 'Na fila', variant: 'secondary', filter: 'queued' };
  if (v === -2) return { label: 'Fora do horário', variant: 'destructive', filter: 'issue' };
  if (v === -3) return { label: 'Enviado por e-mail', variant: 'default', filter: 'issue' };
  if (v > 0) return { label: `${v} enviados`, variant: 'success', filter: 'done' };
  return { label: 'Indefinido', variant: 'secondary', filter: 'all' };
}

/** Campanha manual — alcance ou "Enviando". */
export function manualReachStatus(received?: number): ReachStatus {
  const v = received ?? 0;
  if (v === 0) return { label: 'Enviando', variant: 'warning' };
  return { label: `${v}`, variant: 'success' };
}

/** Campanha automatizada — alcance numérico. */
export function automatedReachStatus(received?: number): ReachStatus {
  const v = received ?? 0;
  return { label: `${v}`, variant: v > 0 ? 'success' : 'secondary' };
}

/** Campanha upload Metabase — alcance ou fila. */
export function uploadReachStatus(received?: number): ReachStatus {
  const v = received ?? 0;
  if (v === 0) return { label: 'Em fila de envio', variant: 'warning' };
  return { label: `${v}`, variant: 'success' };
}

export function matchesWhatsappFilter(received: number | undefined, filter: WhatsappReachFilter): boolean {
  if (filter === 'all') return true;
  return whatsappReachStatus(received).filter === filter;
}

/** Data/hora exibida no card conforme modo (regras do dash v2). */
export function campaignDisplayDateTime(
  mode: 'manual' | 'automated' | 'upload',
  row: {
    updated?: string;
    created_at?: string;
    frequencia?: string;
    frequencia_unico?: string;
    frequencia_horas?: string;
    data_disparo?: string;
    horario?: string;
  },
): { date?: string; time?: string } {
  if (mode === 'automated') {
    const date = row.frequencia === '31' && row.frequencia_unico ? row.frequencia_unico : row.created_at ?? row.updated;
    return { date, time: row.frequencia_horas };
  }
  if (mode === 'upload' && row.data_disparo) {
    return { date: row.data_disparo, time: row.horario };
  }
  return { date: row.updated ?? row.created_at, time: undefined };
}
